export const capitalizeFirstLetter = <T extends string>(val: T) =>
  (val.charAt(0).toUpperCase() + val.slice(1)) as Capitalize<T>;
